export default {
    methods: {
        getDateStr(date){
            if (!date) return ''
            let date_obj = new Date(date)
            let year = date_obj.getFullYear()
            let month = date_obj.getMonth() + 1
            let day = date_obj.getDate()
            let hours = date_obj.getHours()
            let minutes = date_obj.getMinutes()
            let seconds = date_obj.getSeconds()
            if (day < 10) {
                day = `0${day}`
            }
            if (month < 10) {
                month = `0${month}`
            }
            if (hours < 10) {
                hours = `0${hours}`
            }
            if (minutes < 10) {
                minutes = `0${minutes}`
            }
            if (seconds < 10) {
                seconds = `0${seconds}`
            }
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }
    }
}
